'use client'
import useCollection from '@/utils/hooks/useCollection'
import Link from '@/components/link'
import React, { FC, ReactElement } from 'react'
import styles from './InscriptionSocialRow.module.css'
import VerifiedBadge from '@/components/verified-badge'
import type { InscriptionDetail } from '@/utils/types/inscription'

const InscriptionSocialRow: FC<{ inscription: InscriptionDetail }> = ({
	inscription
}): ReactElement => {
	// Keep the legacy object as a fallback for older cached/API responses.
	const collections = [...(inscription.collections || []), inscription.collection].filter(
		(collection, index, all) =>
			collection?.slug && all.findIndex((item) => item?.slug === collection.slug) === index
	)
	const { data } = useCollection(collections[0]?.slug || '')
	return (
		<div className={styles.socialRow}>
			{collections.length > 0 && (
				<nav aria-label="Collections">
					<ul className={styles.collections}>
						{collections.map(
							(collection) =>
								collection && (
									<li key={collection.slug} className={styles.collection}>
										<Link href={`/collection/${collection.slug}`}>
											{collection.name || collection.slug}
										</Link>
										<VerifiedBadge slug={collection.slug} />
									</li>
								)
						)}
					</ul>
				</nav>
			)}
			<div className={styles.socialPics}>
				{data?.socials?.website && (
					<Link href={data.socials.website}>
						<img src="/linkIcon.svg" alt="Website" className={styles.twitterBlue} />
					</Link>
				)}
				{data?.socials?.discord && (
					<Link href={data.socials.discord}>
						<img src="/discordIcon.svg" alt="Discord" className={styles.twitterBlue} />
					</Link>
				)}
				{data?.socials?.twitter && (
					<Link href={data.socials.twitter}>
						<img src="/twitterGray.svg" alt="Twitter" className={styles.twitterBlue} />
					</Link>
				)}
			</div>
		</div>
	)
}
export default InscriptionSocialRow
